import Message from "../../components/Message";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function Infant(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBack = () => {
    setPageAndDeferNavigate(dispatch, '/demographic', navigate);
  };

  return (
    <Message
      onBack={handleBack}
      title={`We're sorry, we unfortunately are not able to see patients under age 2.`}
      subtitle="Please call 911 in case of an emergency or consult a pediatrician."
    />
  );
}
